import { raf, ric, debounce } from './general';

// setup idling so that at least 1 action is dispatched to the store every 30
// seconds
//
// Taken from page 65 of "Human Redux" by Hendrik Joreteg
export default store => {
  const idleDispatcher = () => {
    store.dispatch({ type: 'APP_IDLE' });
  };

  // Create a version of the function that is
  // deBounced to 30 seconds
  const deBounced = debounce(() => {
    // The requestAnimationFrame ensures it doesn't run when tab isn't active
    // the requestIdleCallback makes sure the browser isn't busy with something
    // else.
    raf(() =>
      // this timeout option for requestIdleCallback is a maximum amount of time
      // to wait. I'm including it here since there have been a few browser bugs where
      // for various reasons browsers fail to trigger idle callbacks without this argument.
      ric(idleDispatcher, { timeout: 500 })
    );
  }, 30_000);

  store.subscribe(deBounced);
};
